import BGGreen from '../../../assets/images/condition-bg-green.png'
import {ReactComponent as RightArrow} from '../../../assets/image/icons/right-arrow.svg';
import {ReactComponent as EqualIcon} from '../../../assets/image/icons/equal.svg';
import { DroppableComponent } from './DroppableComponent';
import { FunctionalIndicatorComponent } from './FunctionalIndicatorComponent';
import { technicalIndicators } from './AlogPanels';
import { useCallback, useEffect, useState } from 'react';

import errorIcon from '../../../assets/image/icons/error.png'
import { Tooltip } from '@mui/material';
import { useParams } from 'react-router-dom';

export const ConditionalComponent = ({
    conditionOperator, setAlgoData, algoIndex, dndRequest
}) => {
    const params = useParams()
    const panelCss = `bg-white relative text-black text-sm w-[70px] h-[43px] text-center flex justify-center items-center outline-none rounded-[10px] overflow-hidden`
    const [leftCondition, setLeftCondition] = useState('')
    const [rightCondition, setRightCondition] = useState('')
    const [rightValue, setRightValue] = useState(0)
    const getIcon = (operator) => {
        if(operator === 'or' || operator === 'and') return operator;
        else if(operator === '<') return <RightArrow className='w-[20px] rotate-180'/>
        else if(operator === '>') return <RightArrow className='w-[20px]'/>
        else if(operator === '=') return <EqualIcon className='w-[20px]'/>
        else if(operator === 'crossover_above') return <RightArrow className='w-[20px] transform rotate-[-45deg]'/>
        else if(operator === 'crossover_below') return <RightArrow className='w-[20px] transform rotate-[45deg]'/>
    }


    const handleClear = (algoIndex) => {
        setAlgoData('rightLogicComponent', {
            index: algoIndex,
            componentName: '',
        })
        setAlgoData('rightLogicValue', {
            index: algoIndex,
            value: 0
        })
        setRightCondition("")
    }

    const func = useCallback(() => {
        if(params?.id) {
            let indicators = ''
            indicators = dndRequest[algoIndex]?.leftLogic?.componentName
            setLeftCondition(technicalIndicators.find((indicator) => indicator.title === indicators))

            if(dndRequest[algoIndex]?.rightLogic?.type === 'component') {
                setRightCondition(technicalIndicators.find((indicator) => indicator.title === dndRequest[algoIndex]?.rightLogic?.componentName))
            }
            else {
                console.log('working',dndRequest[algoIndex]?.rightLogic?.value);
                setRightValue(dndRequest[algoIndex]?.rightLogic?.value)
            }
        }
        
    }, [dndRequest, technicalIndicators])

    useEffect(() => {
        func();
    },[])


    return (
        <div className={`w-[200px] h-[50px] flex flex-col items-center justify-center`} style={{
            backgroundImage: `url(${BGGreen})`,
            backgroundSize: '100% 100%'
        }}>
            <div className='flex flex-row gap-[3px] justify-center items-center'>
                <div className='relative'>
                    <DroppableComponent accepts={"technicalPanel"} callback={(res) => {
                        setLeftCondition(technicalIndicators.find((indicator) => indicator.id === res.id))
                        setAlgoData('leftLogicComponent', {
                            index: algoIndex,
                            type: 'component',
                            componentName: technicalIndicators.find((indicator) => indicator.id === res.id)?.title,
                            timeRange: 14,
                            status: 'Open'
                        })
                    }} 
                    classes={`${panelCss} ${dndRequest[algoIndex].error ? 'border-[1px] border-solid border-[#ff0000]' : ''}`} 
                    contentEditable="false" 
                    isNumeric={true} 
                    keyLogic={(val) => {
                        if(leftCondition == '') {
                            setAlgoData('leftLogicValue', {
                                index: algoIndex,
                                value: val
                            })
                        }
                    }}>
                        {leftCondition !== '' && <FunctionalIndicatorComponent indicatorType={leftCondition?.title} algoIndex={algoIndex} setAlgoData={setAlgoData} algoPart={'left'}/>}        
                    </DroppableComponent>
                    {/* {dndRequest[algoIndex].error && <img src={errorIcon} className='absolute top-[-5px] right-[-5px] h-[20px] w-[20px]'/>} */}
                </div>

                <span className='text-white text-[9px] font-bold uppercase'>{getIcon(conditionOperator)}</span>

                <div className='relative'>
                    <DroppableComponent accepts={"technicalPanel"} callback={(res) => {
                        setRightCondition(technicalIndicators.find((indicator) => indicator.id === res.id))
                        setAlgoData('rightLogicComponent', {
                            index: algoIndex,
                            type: 'component',
                            componentName: technicalIndicators.find((indicator) => indicator.id === res.id)?.title,
                            timeRange: 14,
                            status: 'Open'
                        })
                    }} 
                    classes={`${panelCss} ${rightCondition === '' ? 'leading-[40px]' : ''} ${dndRequest[algoIndex].error ? 'border-[1px] border-solid border-[red]' : ''}`} 
                    contentEditable="true" 
                    isNumeric={true} 
                    keyLogic={(val) => {
                        if(rightCondition == '') {
                            // setRightValue(parseInt(val))
                            // handlerightValChange(parseInt(val))
                            setAlgoData('rightLogicValue', {
                                index: algoIndex,
                                value: val
                            })
                        }
                    }}>
                        {rightCondition !== '' ? <FunctionalIndicatorComponent indicatorType={rightCondition.title} algoIndex={algoIndex} setAlgoData={setAlgoData} algoPart={'right'}/> : (rightValue ? rightValue  : '')
}        
                    </DroppableComponent>
                    {dndRequest[algoIndex].error && <Tooltip title="Calculated value is incorrect. Please change and try again." >
                            <img src={errorIcon} className='absolute top-[-5px] right-[-5px] h-[20px] w-[20px] cursor-pointer'/>
                        </Tooltip>}
                    {
                        rightCondition !== '' ?
                            <span className='text-[10px] font-bold absolute top-[35%] right-[-10px] text-white cursor-pointer' onClick={() => handleClear(algoIndex)} >
                                <Tooltip title="Clear" >
                                X
                                </Tooltip> 
                            </span>
                        : ''
                    }
                    
                </div>
            </div>
        </div>
    );
}